import animate from "../../awrabet/utils/animate";
export * from "../../awrabet/utils/animate";
export default animate;